import { render, staticRenderFns } from "./brandsView.vue?vue&type=template&id=03b7fa50&scoped=true"
import script from "./brandsView.vue?vue&type=script&lang=js"
export * from "./brandsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03b7fa50",
  null
  
)

export default component.exports